import React from 'react';

const MyComponentCard = ({ seleccionado, onSeleccionar, image, altText, cardText }) => {
    const handleClick = () => {
        onSeleccionar(!seleccionado); // Invierte el valor y lo pasa a la función onSeleccionar
    };

    return (
        <div
            className={`my-card ${seleccionado ? 'my-card-seleccionado' : ''}`}
            onClick={handleClick}
        >
            <div className="card-content">
                <img src={image} alt={altText} />
                <p>{cardText}</p>
            </div>
        </div>
    );
};

export default MyComponentCard;